import { render } from "./InterrogacaoHover.vue?vue&type=template&id=2b5ede01&scoped=true"
import script from "./InterrogacaoHover.vue?vue&type=script&lang=js"
export * from "./InterrogacaoHover.vue?vue&type=script&lang=js"

import "./InterrogacaoHover.vue?vue&type=style&index=0&id=2b5ede01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5ede01"]])

export default __exports__